// extracted by mini-css-extract-plugin
module.exports = {"BackBar":"Ticketing_BackBar__iSj1t","SubmitBox":"Ticketing_SubmitBox__1qO_k"};